<template>
  <div class="templateList">
    <div class="header">
      <div class="header-search">
        <el-input
          class="header-search-item"
          placeholder="搜索类别名称"
          v-model="key"
          clearable
          @keyup.enter.native="getSearch()"
          @clear="getSearch"
          ><i
            slot="suffix"
            class="el-input__icon el-icon-search"
            @click="getSearch()"
          ></i
        ></el-input>
      </div>
      <el-button type="primary" @click="operateModule()">新建类别</el-button>
    </div>

    <div class="tips-box">
      <span class="tips">
        <i class="el-icon-warning-outline" type="primary"></i>
        什么是类别？</span
      >类别是帮助消息模版进行分类的功能，发送消息的时候可以让您更快地找到对应模版。
    </div>
    <div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="name" label="类别名称" :align="alignType">
        </el-table-column>
        <el-table-column label="创建人" :align="alignType">
          <template slot-scope="scope">
            <div>{{ scope.row.createBy || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" :align="alignType">
          <template slot-scope="scope">
            <div>{{ scope.row.createTime || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" :align="alignType">
          <template slot-scope="scope">
            <el-button type="text" @click="operateModule(scope.row, 'edit')"
              >编辑</el-button
            >
            <el-popconfirm
              confirm-button-text="确认"
              cancel-button-text="取消"
              icon="el-icon-info"
              icon-color="red"
              title="是否确认删除该消息类别？"
              @confirm="deleteRow(scope.row)"
            >
              <el-button type="text" slot="reference">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-page">
        <el-pagination
          background
          layout="total,prev, pager, next, sizes, jumper"
          :current-page.sync="pageNum"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="pageSize"
          :total="totalRecord"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogFormVisible"
      width="25%"
      class="message-dialog"
    >
      <el-form :model="form">
        <el-form-item label="">
          <div>类别名称：</div>
          <el-input
            type="text"
            v-model="form.name"
            autocomplete="off"
            placeholder="请输入"
            maxlength="15"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addOrEdit()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  categoryPage,
  addOrEditCategory,
  deleteCategory
} from '@/common/api/corporateInteraction/messageTemplate'

export default {
  name: 'CategorySetList',
  data() {
    return {
      key: '',
      type: '',
      totalRecord: 0,
      pageNum: 1,
      pageSize: 10,
      typeOptions: [],
      dialogFormVisible: false,
      dialogTitle: '新建',
      tableData: [],
      form: {
        name: '',
        id: ''
      },
      alignType: 'center'
    }
  },
  mounted() {
    this.getSearch()
  },
  methods: {
    // 操作弹框
    operateModule(row, type) {
      if (type == 'edit') {
        this.dialogTitle = '编辑'
        this.form.id = row.id
        this.form.name = row.name
      } else {
        this.dialogTitle = '新建'
        this.form = {
          id: '',
          name: ''
        }
      }
      this.dialogFormVisible = true
    },
    // 删除项
    deleteRow(row) {
      deleteCategory({ id: row.id }).then((res) => {
        const { data, code, msg } = res.data
        if (code == '0000') {
          this.$message.success(msg)
          this.getSearch()
        }
      })
    },
    // 新增编辑项
    addOrEdit() {
      const data = {
        ...this.form
      }
      addOrEditCategory(data).then((res) => {
        const { data, code, msg } = res.data
        if (code == '0000') {
          this.$message.success(msg)
          this.dialogFormVisible = false
          this.getSearch()
        } else {
          this.$message.error(msg)
        }
      })
    },
    // 列表搜索
    getSearch() {
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        key: this.key
      }
      categoryPage(params).then((res) => {
        const { data, code, msg } = res.data
        if (code == '0000') {
          this.tableData = data.list
          this.totalRecord = data.total
        }
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getSearch()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getSearch()
    }
  }
}
</script>

<style lang="scss" scoped>
.templateList {
  .header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    &-search {
      display: flex;
      &-item {
        margin-right: 20px;
      }
      /deep/.el-input__inner {
        width: 240px;
      }
    }
  }
  .el-table {
    /deep/.el-button {
      margin-right: 10px;
    }
  }
  .table-page {
    margin: 20px 0;
    text-align: right;
  }
  .tips-box {
    margin-bottom: 10px;
    font-size: 14px;
    color: #999999;
    .tips {
      color: #1890ff;
    }
  }
}
.message-dialog {
  /deep/.el-form-item__content {
    width: 80%;
  }
}
</style>

